import { useCompanyCanonicalUrl } from '@/hooks/useCompany';
import md5 from 'md5';

export function useCompanyVariant() {
  const canonicalUrl = useCompanyCanonicalUrl();

  if (canonicalUrl === '') {
    /** used outside of company reports */
    return 'control';
  }
  const hash: string = md5(canonicalUrl);
  const least = hash.slice(hash.length - 1);
  const leastNumber = parseInt(least, 16);
  const variantIndex = leastNumber % 6;

  const variants = [
    'variant1', // remove organisation entity
    'variant2', // reshape webpage corporation and add the ticker symbol
    'variant3', // move FAQ from split pages to overview page
    'variant4', // enahnce FAQ with risks and rewards
    'variant5', // all activated
    'control',
  ] as const;

  return variants[variantIndex];
}

export default useCompanyVariant;
